/* eslint-disable import/first */
import React, { useState, useEffect, createRef, useRef } from "react";
import 'suneditor/dist/css/suneditor.min.css';
import SunEditor, { buttonList } from "suneditor-react";
import axios from "axios";
import { useSelector } from "react-redux";
import Page404 from "app/not-found";
import { Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import styled from "styled-components";
import Resizer from "react-image-file-resizer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { fr } from 'date-fns/locale/fr';
registerLocale('fr', fr);

const UploadProfile = styled(Upload)`
  .ant-upload {
    width: 50px !important;
    height: 50px !important;
  }
`;

const API_URL = "https://ahuncycle-backend.vercel.app";
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageModifierArticle = (myRef) => {
  const { user } = useSelector((state) => state.user);
  const [article, setArticle] = useState(null);
  const [articles, setArticles] = useState([]);
  const editorRef = createRef();
  const [contents, setContents] = useState('');
  const [categorie, setCategorie] = useState('Articles');
  const [articleSelected, setArticleSelected] = useState(-1);
  const [href, setHref] = useState('');
  const [date, setDate] = useState('');
  const [createdAt, setCreatedAt] = useState('');
  const [description, setDescription] = useState("");
  const editor = useRef(null);
  const hrefRef = useRef(myRef);
  const [avatarPreview, setAvatarPreview] = useState(null);
  const [avatarFile, setAvatarFile] = useState(null);

  const getSunEditorInstance = (sunEditor) => {
    if (sunEditor) editor.current = sunEditor;
  };

  useEffect(() => {
    if (user) {
      const getArticles = async () => {
        try {
          const response = await axiosInstance.get("api/articles");
          setArticles(response.data);
        } catch (error) {
          console.log("erreur:" + error);
        }
      };
      getArticles();
    }
  }, []);

  useEffect(() => {
    if (user && editor.current) {
      if (article && articleSelected !== "-1") {
        setContents(article.html);
        setHref(article.href);
        setTimeout(() => {
          try {
            editor.current.setContents(article.html);
          } catch (err) {
            console.error("Erreur setContents:", err);
          }
        }, 50);
      } else {
        setContents("");
        setHref("");
        setTimeout(() => {
          try {
            editor.current.setContents("");
          } catch (err) {
            console.error("Erreur reset editor:", err);
          }
        }, 50);
      }
    }
  }, [categorie, article, href, articleSelected, user]);

  const findCategorie = () => {
    return articles.filter((article) => article.categorie === categorie);
  };

  const articlesParCategorie = findCategorie();

  const changeCategorie = (e) => {
    e.preventDefault();
    setCategorie(e.target.value);
    setArticleSelected("-1");
  };

  const changeArticle = (e) => {
    e.preventDefault();
    setArticleSelected(e.target.value);
    if (e.target.value === "-1") {
      setArticle(null);
      setContents("");
      setHref("");
      setAvatarPreview(null);
      setDescription("");
      setDate("");
      setCreatedAt("");
    } else {
      const selected = articlesParCategorie[e.target.value];
      setArticle(selected);
      setContents(selected.html);
      setHref(selected.href);
      setAvatarPreview(selected.image);
      setDescription(selected.description);
      setDate(selected.date);
      setCreatedAt(selected.createdAt);
    }
  };

  const updateArticle = async (html) => {
    try {
      const form = new FormData();
      form.append('href', hrefRef.current.value);
      form.append('html', html);
      form.append('image', document.querySelector("#image").src);
      form.append('date', document.querySelector("#date").value);
      form.append('createdAt', document.querySelector("#createdAt").value);
      form.append('description', document.querySelector("#description").value);
      form.append('categorie', document.querySelector("#categorie").value);
      await axiosInstance.post("api/articles", form);
      alert("Enregistrement réussi!");
    } catch (error) {
      alert(error + " Envoie de: " + html.length * 2000 / 1024 / 1024 + "MB. Limite permise: 4.5MB");
      console.log("Erreur:", error);
    }
  };

   async function getImageURL (file)  {
        const formData = new FormData();
        formData.append("image", file);
        console.log("Filename:" + file.name);
    
        try {
          if (file)
          {
            const response = await axiosInstance.post("api/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data", 
                },
            });
            return response;
          }
        } catch (err) {
            console.log("Erreur:" + err);
            return null;
        }
      return null;
    };
  
  const handleAvatarChange = async (info) => {
    const file = info.file.originFileObj;
    if (file && file !== avatarFile) {
      try {
        const response = await getImageURL(file);
        setAvatarFile(file);
        setAvatarPreview(response.data);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleSave = (editorContent) => {
    setHref(hrefRef.current.value);
    updateArticle(editorContent);
  };

  async function onImageUploadBefore(files, info, uploadHandler) {
    const formData = new FormData();
    formData.append("image", files[0]);

    try {
      const response = await axiosInstance.post("api/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const responseSunEditor = {
        result: [
          {
            url: response.data,
            name: files[0].name,
            size: files[0].size,
          },
        ],
      };

      uploadHandler(responseSunEditor);
    } catch (err) {
      console.log("Erreur:", err);
    }
    return;
  }

  if (!user) return <Page404 />;

  return (
    <div>
      <table>
        <tbody>
          <tr>
            <td>
              <p>Catégorie:</p>
              <select
                style={{ width: "200px" }}
                name="categorie"
                id="categorie"
                onChange={changeCategorie}
                value={categorie}
              >
                <option value="Articles">Articles</option>
                <option value="Projets">Projets</option>
                <option value="Propositions">Propositions</option>
                <option value="Évenements">Événements</option>
                <option value="Conseils">Conseils d'arrondissement</option>
                <option value="Photos">Photos</option>
                <option value="Médias">Médias</option>
              </select>
            </td>
            <td>
              <p>Article:</p>
              <select
                style={{ width: "500px" }}
                name="article"
                onChange={changeArticle}
                value={articleSelected}
              >
                <option value="-1">Sélectionnez un article</option>
                {articlesParCategorie.map((post, i) => (
                  <option key={i} value={i}>
                    {post.titre}
                  </option>
                ))}
              </select>
            </td>
            <td>
              Création:
              <br />
              <DatePicker
                id="createdAt"
                name="createdAt"
                locale="fr"
                selected={createdAt ? new Date(createdAt) : null}
                onChange={(date) => setCreatedAt(date)}
              />
            </td>
            <td>
              Image:
              <br />
              <UploadProfile
                name="avatar"
                listType="picture-circle"
                showUploadList={false}
                beforeUpload={() => true}
                onChange={handleAvatarChange}
                accept="image/*"
              >
                {avatarPreview ? (
                  <img
                    id="image"
                    src={avatarPreview}
                    alt="Avatar"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                ) : (
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Envoyer</div>
                  </div>
                )}
              </UploadProfile>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              Href:
              <input
                ref={hrefRef}
                style={{ width: "100%" }}
                type="text"
                value={href}
                onChange={(e) => setHref(e.target.value)}
              />
            </td>
            <td>
              <p>Date:</p>
              <input
                style={{ width: "100%" }}
                id="date"
                name="date"
                value={date}
                type="text"
                onChange={(e) => setDate(e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <td></td>
            <td colSpan="2">
              <p>Description:</p>
              <input
                id="description"
                name="description"
                value={description}
                style={{ width: "100%" }}
                type="text"
                onChange={(e) => setDescription(e.target.value)}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <br />
      <SunEditor
        ref={editorRef}
        getSunEditorInstance={getSunEditorInstance}
        onSave={handleSave}
        setAllPlugins={true}
        setOptions={{
          buttonList: buttonList.complex,
          iframe: false, // ⛔ Désactiver le mode iframe pour éviter l'erreur
        }}
        onImageUploadBefore={onImageUploadBefore}
        height="100vh"
      />
    </div>
  );
};

export default PageModifierArticle;
